import { render, staticRenderFns } from "./EmployeeRelativeInformationCreateOrUpdate.vue?vue&type=template&id=1f8fbbb2&"
import script from "./EmployeeRelativeInformationCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./EmployeeRelativeInformationCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports